const Config = Object.freeze({
  apiBaseUrl: "https://teamsapi.sofyrus.com/api",
  // apiBaseUrl : 'https://74.48.21.41:3008/api'
});

export default Config;
